// 定义路由
let routes = [
    /* ---------------- 首页与「我的」（带底部菜单） ---------------- */
    {
        path: '/home',
        name: 'appHome',
        component: resolve => require(['../view/home/index'], resolve),
        meta: {
            title: '首页',
            code: 'appHome',
            tabbar: true //是否显示下面的tabbar
        }
    },
    {
        path: '/mine',
        name: 'appMine',
        component: resolve => require(['../view/mine/index'], resolve),
        meta: {
            title: '我的',
            code: 'appMine',
            tabbar: true
        }
    },
    {
        path: '/score',
        name: 'appScore',
        component: resolve => require(['../view/score/index'], resolve),
        meta: {
            title: '成绩曲线',
            code: 'appScore',
            tabbar: true //是否显示下面的tabbar
        }
    },
    {
        path: '/wrong',
        name: 'appWrong',
        component: resolve => require(['../view/wrong/index'], resolve),
        meta: {
            title: '错题本',
            code: 'appWrong',
            tabbar: true //是否显示下面的tabbar
        }
    },
    {
        path: '/examhome',
        name: 'examhome',
        component: resolve => require(['../view/exam/index'], resolve),
        meta: {
            title: '学习',
            code: 'examhome',
            tabbar: true //是否显示下面的tabbar
        }
    },
    {
        path: '/exam/index', //1. : 必传   2. :?选传
        name: 'home',
        component: resolve => require(['../view/exam/index'], resolve),
        meta: {
            code: 'exam'
        },
        redirect: { name: 'introduce' },
        children: [
            {
                path: 'introduce',
                name: 'introduce',
                component: resolve => require(['../view/exam/introduce'], resolve),
                meta: {
                    title: '学习路径',
                    tabbar: true //是否显示下面的tabbar
                }
            },
            {
                path: 'questionsList',
                name: 'questionsList',
                component: resolve => require(['../view/exam/questionsList'], resolve),
                meta: {
                    title: '学习路径',
                    tabbar: true //是否显示下面的tabbar
                }
            },
            {
                path: 'examStatistics',
                name: 'examStatistics',
                component: resolve => require(['../view/exam/examStatistics'], resolve),
                meta: {
                    title: '学习路径',
                    tabbar: true //是否显示下面的tabbar
                }
            },
            {
                path: 'answerList',
                name: 'answerList',
                component: resolve => require(['../view/exam/answerList'], resolve),
                meta: {
                    title: '学习路径',
                    tabbar: true //是否显示下面的tabbar
                }
            },
            {
                path: 'exerciseList',
                name: 'exerciseList',
                component: resolve => require(['../view/exam/exerciseList'], resolve),
                meta: {
                    title: '练习答题',
                    tabbar: true //是否显示下面的tabbar
                }
            }
        ]
    },
    {
        path: '/hwk/home',
        name: 'hwkHome',
        component: resolve => require(['../view/hwk/home'], resolve),
        meta: {
            title: '作业',
            code: 'hwk',
            tabbar: true //是否显示下面的tabbar
        }
    },
    /* 作业详情：明细页，不挂底部菜单，底部是「去提交 / 查看批改」操作条 */
    {
        path: '/hwk/task/:id',
        name: 'hwkTask',
        component: resolve => require(['../view/hwk/task'], resolve),
        meta: {
            title: '作业详情',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/hwk/index',
        name: 'hwkindex',
        component: resolve => require(['../view/hwk/index'], resolve),
        meta: {
            title: '消息列表',
            code: 'cmooc-',
            tabbar: false
        }
    },
    {
        path: '/hwk/detail',
        name: 'hwkdetail',
        component: resolve => require(['../view/hwk/detail'], resolve),
        meta: {
            title: '详情',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/hwk/echart',
        name: 'hwkechart',
        component: resolve => require(['../view/hwk/echart'], resolve),
        meta: {
            title: '小测曲线图',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/hwk/worklist',
        name: 'hwkworklist',
        component: resolve => require(['../view/hwk/echart'], resolve),
        meta: {
            title: '作业列表',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/hwk/mryl',
        name: 'hwkmryl',
        component: resolve => require(['../view/hwk/echart'], resolve),
        meta: {
            title: '每日一练',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/hwk/xuehao',
        name: 'hwkxuehao',
        component: resolve => require(['../view/hwk/echart'], resolve),
        meta: {
            title: '学号',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/hwk/examresult',
        name: 'hwkexamresult',
        component: resolve => require(['../view/hwk/echart'], resolve),
        meta: {
            title: '成绩列表',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/hwk/my',
        name: 'hwkmy',
        component: resolve => require(['../view/hwk/echart'], resolve),
        meta: {
            title: '个人中心',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/login',
        name: 'hwklogin',
        component: resolve => require(['../view/hwk/login'], resolve),
        meta: {
            title: '登录',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/eindex',
        name: 'eindex',
        component: resolve => require(['../view/hwk/manage'], resolve),
        meta: {
            title: '首页',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/forzl',
        name: 'eindex',
        component: resolve => require(['../view/we/listPage'], resolve),
        meta: {
            title: '信箱',
            code: 'hwk',
            tabbar: true //是否显示下面的tabbar
        }
    },
    {
        path: '/hwk/input',
        name: 'hwkinput',
        component: resolve => require(['../view/hwk/addInfoItem'], resolve),
        meta: {
            title: '新增',
            code: 'hwk',
            tabbar: false
        }
    },
    {
        path: '/we',
        name: 'hwkinput',
        component: resolve => require(['../view/we/index'], resolve),
        meta: {
            title: '我们',
            code: 'we',
            tabbar: false
        }
    },
    {
        path: '/ll',
        name: 'hwkinput',
        component: resolve => require(['../view/we/ll'], resolve),
        meta: {
            title: 'love',
            code: 'll',
            tabbar: false
        }
    },
    {
        path: '/last',
        name: 'hwkinput',
        component: resolve => require(['../view/we/last'], resolve),
        meta: {
            title: 'last',
            code: 'last',
            tabbar: false
        }
    },
    {
        path: '/zl',
        name: 'hwkinput',
        component: resolve => require(['../view/we/zl'], resolve),
        meta: {
            title: '你好好的',
            code: 'zl',
            tabbar: false
        }
    },
    {
        path: '/rose',
        name: 'weRose',
        component: resolve => require(['../view/we/rose'], resolve),
        meta: {
            title: '张玲，这束红玫瑰是给你的',
            code: 'rose',
            tabbar: false
        }
    },
    {
        path: '/beat',
        name: 'weBeat',
        component: resolve => require(['../view/we/beat'], resolve),
        meta: {
            title: '气不顺？这儿有个沙包',
            code: 'beat',
            tabbar: false
        }
    },

    /* ---------------- 动态文章页（内容来自后端，可在后台随时改） ---------------- */
    {
        path: '/p/:code',
        name: 'wePage',
        component: resolve => require(['../view/we/page'], resolve),
        meta: {
            title: '信',
            code: 'wePage',
            tabbar: false
        }
    },

    /* ---------------- 管理后台（桌面端布局，独立于移动端页面） ---------------- */
    {
        path: '/admin/login',
        name: 'adminLogin',
        component: resolve => require(['../view/admin/login'], resolve),
        meta: {
            title: '信箱后台 · 登录',
            code: 'adminLogin',
            tabbar: false,
            admin: true
        }
    },
    {
        path: '/admin',
        name: 'admin',
        component: resolve => require(['../view/admin/layout'], resolve),
        meta: {
            title: '信箱后台',
            code: 'admin',
            tabbar: false,
            admin: true
        },
        redirect: '/admin/pages',
        children: [
            {
                path: 'pages',
                name: 'adminPages',
                component: resolve => require(['../view/admin/pages'], resolve),
                meta: { title: '页面管理', code: 'adminPages', tabbar: false, admin: true }
            },
            {
                path: 'edit',
                name: 'adminEdit',
                component: resolve => require(['../view/admin/edit'], resolve),
                meta: { title: '编辑页面', code: 'adminEdit', tabbar: false, admin: true }
            },
            {
                path: 'preview',
                name: 'adminPreview',
                component: resolve => require(['../view/admin/preview'], resolve),
                meta: { title: '页面预览', code: 'adminPreview', tabbar: false, admin: true }
            },
            {
                path: 'visits',
                name: 'adminVisits',
                component: resolve => require(['../view/admin/visits'], resolve),
                meta: { title: '访问记录', code: 'adminVisits', tabbar: false, admin: true }
            }
        ]
    }
]

// 404 页面
routes.push({
    path: '*',
    component: resolve => require(['../view/404.vue'], resolve)
})

export default routes
